(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CovidQuestion', CovidQuestion);

    CovidQuestion.$inject = ['$resource'];

    function CovidQuestion ($resource) {
        var resourceUrl =  'api/covid-questions/:id';

        return $resource(resourceUrl, {}, {
            'findAllByFacility': {url: 'api/covid-questions/by-facility/:id', method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
